import { CURRENCIES_OPTIONS } from 'constants/currency';
import { useMemo, useState } from 'react';
import { localStorageFavoritesKey } from 'utils/storage';

export const useFavorites = ({ currenciesType }) => {
  const [favorites, setFavorites] = useState({});

  const getFavoritesByCurrenciesType = () => {
    const favoritesValues = Object.values(favorites);

    if (currenciesType === CURRENCIES_OPTIONS.all) {
      return favoritesValues;
    }

    return favoritesValues.filter(({ type }) => currenciesType === type);
  };

  const addFavorites = favorites => {
    setFavorites(favorites);
  };

  const handleSwitchCurrencyInFavorites = currency => event => {
    event.preventDefault();

    const isInFavorites = !!favorites[
      getFavoritesKey(currency.slug, currency.type)
    ];

    if (isInFavorites) {
      removeFromFavorites(currency);
    } else {
      addToFavorites(currency);
    }
  };

  const addToFavorites = currency => {
    const updatedFavorites = {
      ...favorites,
      [getFavoritesKey(currency.slug, currency.type)]: currency,
    };

    setFavorites(updatedFavorites);

    try {
      localStorage.setItem(
        localStorageFavoritesKey,
        JSON.stringify(updatedFavorites)
      );
    } catch (err) {
      console.error('Error saving to localStorage:', err);
    }
  };

  const removeFromFavorites = ({ slug, type }) => {
    const removedKey = getFavoritesKey(slug, type);

    const updatedFavorites = Object.keys(favorites).reduce((result, key) => {
      if (removedKey === key) {
        return result;
      }

      return {
        ...result,
        [key]: favorites[key],
      };
    }, {});

    setFavorites(updatedFavorites);

    try {
      localStorage.setItem(
        localStorageFavoritesKey,
        JSON.stringify(updatedFavorites)
      );
    } catch (err) {
      console.error('Error saving to localStorage:', err);
    }
  };

  const currentFavorites = useMemo(() => {
    return getFavoritesByCurrenciesType();
  }, [favorites, currenciesType]);

  const getFavoritesKey = (slug, type) => `${slug}-${type}`;

  return {
    currentFavorites,
    addFavorites,
    handleSwitchCurrencyInFavorites,
  };
};

export default useFavorites;
